import React, { forwardRef } from 'react';
import MUIListSubheader, {
  ListSubheaderProps as MUIListSubheaderProps,
} from '@material-ui/core/ListSubheader';

interface ListSubheaderProps extends MUIListSubheaderProps {}

const ListSubheader = forwardRef<HTMLLIElement, ListSubheaderProps>(
  (props, ref) => {
    const { disableGutters = true, ...rest } = props;
    return (
      <MUIListSubheader {...rest} ref={ref} disableGutters={disableGutters}>
        {props.children}
      </MUIListSubheader>
    );
  }
);

ListSubheader.displayName = 'ListSubheader';

export default ListSubheader;
